import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {ToolItem} from '@pb/kit-component-tools-ribbon';

type Props = {
    selectedCount: number,
    onClear: () => void,
};

export const DeselectAllView: React.FC<Props> = ({selectedCount, onClear}) => {
    if (selectedCount === 0) {
        return null;
    }

    return (
        <ToolItem>
            <FlatButton onClick={onClear}>Deselect All</FlatButton>
        </ToolItem>
    );
};
